<template>
    <b-container align="center" justify="center" >
      <b-row>
        <b-col>
        YOLO Activity XXX {{ id }}<br/>

        <b-btn color="success" class="mt-4" style="width: 200px" @click="openX">Spawn Activity - X</b-btn>
        <b-btn   color="success" class="mt-4" style="width: 200px" @click="open">Spawn ActivitY</b-btn>

        <b-input
            v-model="input" 
            label="put something" 
            required
            ></b-input>

        Result from child {{ result }}

        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        YOLO XXX<br/>
        YOLO XXX<br/>

        </b-col>
      </b-row>
    </b-container>
</template>



<script>
import EventBus from "@/utils/EventBus";
import  Activity from "../Activity"
import  ActivityManager from "../ActivityManager"
import  SampleActivityX from "./SampleActivityX"
import Perms from "@/server/Perms";

/**
 * @extends Activity
 */
export default {
  name: "SampleActivityX",
  permission: Perms.TEST_A,

  components: {},
  mounted() {

  },
  created() {
    if(SampleActivityX['_id'] === undefined){
      SampleActivityX['_id'] = 0;
    }
    this.id =SampleActivityX['_id']++;
    
  },

  methods: {

  ... Activity.methods,

  beforeClose(){
      this.setResult(this.input);
  },
  async open(){
    //const act = require("./SampleActivity");
    // let result = await (await ActivityManager.showActivity(act)).getResult();
    // if(result != null){
    //   this.result = result;
    // }
  },

  async openX(){
    let result = await(await ActivityManager.showActivity(SampleActivityX)).getResult();
    if(result != null){
      this.result = result;
    }
  },

  getTitle(){
    return $tr("simpleActivityX.this.id","Simple ActivityX ",this.id);
  }


  },

  props: [],
  data: function() {
    return {
      input: "",
      result: "",
      id:0,
      
    };
  }
};
</script>